import $ from 'jquery'
import Layer from 'ol/layer/Layer'

/**
 * Table Of Contents (layer list) UI class
 * @param {Object} config
 * @constructor
 */
export default class Toc {
  constructor(config) {
    $.extend(this, config)

    this.el = $('#sidr-right')

    // toggle collapse for all legends
    this.collapseActive = true
    this.groupClassPrefix = 'toc-group-'

    this.toggleButton = $('.open-right-sidr')
    this.toggleButton.on('click', this.toggle.bind(this))

    this.backdrop = $('div.sidr-backdrop')

    this.backdrop.on('click', this.handleBackdropClick.bind(this))

    this.$legendsToggleAllButton = $('#collapse-layerlist')
    this.$toc = $('#toc-container')
    this.$layers = $('#toc-layers')

    this.$legendsToggleAllButton.on(
      'mousedown',
      this.toggleAllLegends.bind(this)
    )
    this.$toc.on('click', this.handleTocClick.bind(this))
    this.$toc.on('change', this.handleChange.bind(this))

    this.hidden = true
  }

  toggle() {
    if (this.hidden) {
      this.el.css({
        display: 'block',
        transform: 'translate(-100%,0)'
      })
      this.backdrop.removeClass('hide')
      this.hidden = false
    } else {
      this.el.css({
        display: 'hidden',
        transform: 'translate(12px,0)'
      })
      this.backdrop.addClass('hide')
      this.hidden = true
    }
  }

  handleBackdropClick(e) {
    this.toggle()
  }

  /**
   * Render layer controls
   */
  render() {
    var $control, $group, groupName

    this.$layers.empty()

    this.config.layers.forEach(
      function(layer) {
        groupName = this.getLayerGroupName(layer)
        $control = this.createControl(layer)
        $group = this.getGroupFromName(groupName)

        if (groupName && $group.length) {
          // Add layer to existing group
          this.getGroupContainer($group).prepend($control)
        } else if (groupName) {
          // Create new group and add layer
          $group = this.createGroup(groupName)
          this.getGroupContainer($group).prepend($control)
          this.$layers.prepend($group)
        } else {
          // If no groups i specified use default layer container
          this.$layers.prepend($control)
        }

        var allOff = this.isAllGroupCheckboxesUnchecked($group)
        if (groupName && allOff) {
          $group.find(':checkbox:first').prop('checked', false)
        } else if (groupName && !allOff) {
          $group.find(':checkbox:first').prop('checked', true)
        }
      }.bind(this)
    )
  }

  /**
   * Toggles all layer legends
   */
  toggleAllLegends() {
    if (this.collapseActive) {
      this.collapseActive = false
      this.$toc.find('.panel-collapse:has(img)').addClass('in')
    } else {
      this.collapseActive = true
      this.$toc.find('.panel-collapse').removeClass('in')
    }
  }
  /**
   * Enables toggling on label click
   * @param  {event} event
   */
  handleTocClick(event) {
    if ($(event.target).is('input')) {
      return // to prevent change trigger if user clicks directly on checbox input element
    } else if ($(event.target).closest('.collapse-layer').length) {
      $(event.target)
        .closest('.panel')
        .find('.panel-collapse:first')
        .toggleClass('in')
    } else if ($(event.target).closest('.panel').length) {
      const checkbox = $(event.target)
        .closest('.panel')
        .find(':checkbox:first')
      checkbox.prop('checked', !checkbox.prop('checked'))
      checkbox.trigger('change')
    }
  }
  /**
   * Toggle layers on switch change
   * @param  {event} event
   */
  handleChange(event) {
    var $target = $(event.target)
    var index = $target.attr('data-layer-index')
    var name = $target.attr('name')
    var checked = $target.prop('checked')
    if (name === 'TocGroupSwitcherCheckbox') {
      const checkbox = $target
        .closest('.toc-group')
        .find(':checkbox[name="toc-layer-switcyer-checkbox"]')
      checkbox.prop('checked', checked)
      checkbox.trigger('change')
    } else {
      this.toc.toggleLayer(index, checked)
      const $group = $target.closest('.toc-group')
      this.toggleGroupBasedOnLayersVisibiblity($group)
    }
  }
  /**
   * Create a layer control element
   * @param {Object} $group
   */
  toggleGroupBasedOnLayersVisibiblity($group) {
    var checkbox = $group.find('.panel-heading :checkbox:first')
    if ($group.length && this.isAllGroupCheckboxesUnchecked($group)) {
      checkbox.prop('checked', false)
    } else if ($group.length) {
      checkbox.prop('checked', true)
    }
  }
  /**
   * Create a layer control element
   * @param {Layer} layer
   * @return {Object}  jQuery DIV-element
   */
  createControl(layer) {
    var $wrapper, $input, $inputWrapper, $legend, $legendWrapper, callapseId

    callapseId = 'TocLayerCollapse-' + layer.index_

    // Create main control element
    $wrapper = $('<div>', { class: 'panel panel-default tocWrapper' })

    // Create legend element
    if (layer.metadata && layer.metadata.legend) {
      $legend = this.createLegend(
        layer.metadata.legend,
        layer.source.params ? layer.source.params.access_token : undefined
      )
    }

    // Create HTML structure
    var html = '<div class="panel-heading">'
    html += '   <div class="checkbox">'
    html += '       <label class="tocInputWrapper">'
    html += layer.name || 'Unnamed layer'
    html += '       </label>'
    html += '   </div>'

    if ($legend) {
      html +=
        '<a class="collapse-layer" data-toggle="collapse" data-target="#' +
        callapseId +
        '"><i class="fa fa-bars"></i></a>'
    }

    html += '</div>'

    if ($legend) {
      html +=
        '<div id="' +
        callapseId +
        '" class="panel-collapse panel-collapse-layerlist collapse">'
      html += '   <div class="panel-body">'
      html += '</div>'
    }

    html += '</div>'

    $wrapper.html(html)

    // Create and add input
    $input = this.createLayerControlInput(layer)
    $inputWrapper = $wrapper.find('.checkbox')
    $input.prependTo($inputWrapper)

    // Add legend
    if ($legend) {
      $legendWrapper = $wrapper.find('.panel-body:first')
      $legend.appendTo($legendWrapper)
    }

    return $wrapper
  }
  /**
   * Create a checkbox based on layer visibility
   * @param {Layer} layer
   * @return {Object} jQuery input element
   */
  createLayerControlInput(layer) {
    var inputName = 'toc-layer-switcyer-checkbox'
    var checked

    checked =
      layer.mapLayer_.getVisible() ||
      (layer.offlineLayer_ && layer.offlineLayer_.getVisible())
    var $input = $('<input>', {
      type: 'checkbox',
      name: inputName,
      'data-layer-index': layer.index_,
      checked: checked
    })

    return $input
  }
  /**
   * Create a group checkbox element based
   * @param {String} layerType
   * @return {Object} jQuery input element
   */
  createGroupControlInput(checked) {
    var inputName = 'TocGroupSwitcherCheckbox'
    var $input = $('<input>', {
      type: 'checkbox',
      name: inputName,
      checked: checked === true
    })

    return $input
  }
  /**
   * Create a layer control element
   * @param {Object} $group
   * @return {bool} Returns true if all checkboxes in group are unchecked
   */
  isAllGroupCheckboxesUnchecked($group) {
    return $group.find('.toc-group-container :input:checked').length < 1
  }

  getLegendAccessToken(legend, sourceAccessToken) {
    if (legend.access_token === false) {
      return undefined
    }

    if (legend.access_token !== undefined) {
      return legend.access_token
    }

    return sourceAccessToken
  }

  /**
   * Create a legend
   * @param {Object} legend
   * @return {Object} jQuery legend element
   */
  createLegend(legend, sourceAccessToken) {
    var $legend

    if (legend && !Array.isArray(legend) && legend.url) {
      $legend = this.createLegendFromUrl(
        legend.url,
        this.getLegendAccessToken(legend, sourceAccessToken)
      )
    } else if (Array.isArray(legend)) {
      $legend = $('<div>')
      legend.forEach(l => {
        this.createLegendFromUrl(
          l.url,
          this.getLegendAccessToken(l, sourceAccessToken)
        ).appendTo($legend)
      })
    }

    return $legend
  }
  /**
   * Create a legend from URL
   * @param {String} url
   * @return {Object} jQuery image element
   */
  createLegendFromUrl(url, accessToken) {
    if (accessToken) {
      // Ugly hack since IE does not support URL-object
      if (url && url.indexOf('?') !== -1) {
        url = url + '&'
      } else {
        url = url + '?'
      }

      url = url + 'access_token=' + accessToken
    }
    var $imageWrapper = $('<div>')
    var $image = $('<img>').attr('src', url)

    $image.appendTo($imageWrapper)

    return $imageWrapper
  }
  /**
   * Get a layer group name from metadata
   * @param  {Layer} layer
   * @return {string} group name
   */
  getLayerGroupName(layer) {
    var groupName

    if (layer.metadata && layer.metadata.group) {
      groupName = layer.metadata.group
    }

    return groupName
  }
  /**
   * Create a layer group container
   * @param  {string} name
   * @return {object} jQuery div element
   */
  createGroup(name) {
    var $group, $input, groupNameSanitized, groupClassName, groupHtml

    groupNameSanitized = this.groupNameSanitize(name)
    groupClassName = this.groupClassPrefix + groupNameSanitized

    $group = $('<div></div>').addClass(
      'toc-group panel panel-default ' + groupClassName
    )

    groupHtml = ''
    groupHtml += '<div class="panel-heading">'
    groupHtml += '<div class="checkbox">'
    groupHtml +=
      '<label class="tocInputWrapper toc-group-label">' + name + '</label>'
    groupHtml += '</div>'
    groupHtml +=
      '<a data-toggle="collapse" class="collapse-layer" data-target="#' +
      groupNameSanitized +
      '"><i class="fa fa-bars"></i></a>'
    groupHtml += '</div>'
    groupHtml +=
      '<div id="' +
      groupNameSanitized +
      '" class="panel-collapse collapse toc-group-container"></div'

    $group.html(groupHtml)

    $input = this.createGroupControlInput('checked')
    $input.prependTo($group.find('.checkbox'))

    return $group
  }
  /**
   * Gets group div from group name
   * @param  {string} groupName
   * @return {object} jQuery div element
   */
  getGroupFromName(groupName) {
    var groupNameSanitized = this.groupNameSanitize(groupName)
    return this.$layers.find('.' + this.groupClassPrefix + groupNameSanitized)
  }
  /**
   * Gets groups inner container div from group object
   * @param  {object} $group
   * @return {object} jQuery div element
   */
  getGroupContainer($group) {
    return $group.find('.toc-group-container')
  }
  groupNameSanitize(name) {
    if (!name) {
      return false
    }

    var sanitized = name.toLowerCase()
    sanitized = sanitized.replace(/å/g, 'a')
    sanitized = sanitized.replace(/ä/g, 'a')
    sanitized = sanitized.replace(/ö/g, 'o')
    sanitized = sanitized.replace(/\W/g, '-')

    return sanitized
  }
}
